import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../../constants/common'
import {
  getListingPublishBlockReason,
  LISTING_FORM_FIELD_NAME_PORTALS,
} from '../../../../../RentalPortalListing'
import {
  getHasListingDisconnectedPortals,
  getIsListingUnitLocked,
  getListingFormMissingPublishItems,
} from '../../RentalPortalListingsForm.utils'

export function useRentalPortalListingsFormRestrictions({
  hasLoadError,
  hasPortalsError,
  hasPublishSection,
  isEditMode,
  isLoading,
  isLoadingPortals,
  isReadOnly,
  listing,
  portals,
}) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const selectedPortals = hasPublishSection
    ? values[LISTING_FORM_FIELD_NAME_PORTALS]
    : EMPTY_LIST

  const hasSelectedPortals = selectedPortals.length > 0

  const publishBlockReason = getListingPublishBlockReason({
    missingItems: getListingFormMissingPublishItems({ t, values }),
    t,
  })

  const isPublishBlocked = Boolean(publishBlockReason) && hasSelectedPortals

  const hasUnverifiedPortals =
    (isLoadingPortals || hasPortalsError) && hasSelectedPortals

  const hasDisconnectedPortals = getHasListingDisconnectedPortals({
    hasPortalsError,
    isLoadingPortals,
    portals,
    selectedPortals,
  })

  const disconnectedPortalsReason = hasDisconnectedPortals
    ? t('RentalPortal.ListingFormPublishNotConnectedKey')
    : undefined

  const readOnlyReason = isReadOnly
    ? t('RentalPortal.ListingFormReadOnlyKey')
    : undefined

  const submitTooltip =
    disconnectedPortalsReason ??
    (isPublishBlocked ? publishBlockReason : undefined)

  // TODO: the list serves the publish right per row only, so a new listing
  // publishes on the create right that opened the form
  return {
    isPublishDisabled: isReadOnly,
    isSubmitDisabled:
      isLoading ||
      hasLoadError ||
      isReadOnly ||
      isPublishBlocked ||
      hasUnverifiedPortals ||
      hasDisconnectedPortals,
    isUnitLocked: getIsListingUnitLocked({ isEditMode, listing }),
    notificationBlockReason: readOnlyReason ?? submitTooltip,
    publishDisabledReason: readOnlyReason,
    submitTooltip,
  }
}
